import React, { useState, useEffect } from "react";
import {
  Menu,
  Search,
  ShoppingCart,
  ChevronDown,
  Plus,
  Minus,
  X,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import Helpers from "../Helper/Helpers";
import { useAuth } from "../context/AuthContextAdmin";

// const categories = [
//   {
//     id: 1,
//     name: "Audio/Video",
//     link: "/audio",
//     subCategories: [
//       {
//         id: 1,
//         name: "True Wireless Earbuds",
//         link: "/audio/true-wireless-earbuds",
//       },
//       { id: 2, name: "Neckbands", link: "/audio/neckbands" },
//       { id: 3, name: "Headphones", link: "/audio/headphones" },
//       { id: 4, name: "Speakers", link: "/audio/speakers" },
//     ],
//   },
//   {
//     id: 2,
//     name: "Peripherals",
//     link: "/mobile-accessories",
//     subCategories: [
//       { id: 1, name: "Power Banks", link: "/mobile-accessories/power-banks" },
//       { id: 2, name: "Chargers", link: "/mobile-accessories/chargers" },
//       { id: 3, name: "Cables", link: "/mobile-accessories/cables" },
//     ],
//   },
//   {
//     id: 3,
//     name: "Accessories",
//     link: "/mobile-accessories",
//     subCategories: [
//       { id: 1, name: "Power Banks", link: "/mobile-accessories/power-banks" },
//       { id: 2, name: "Chargers", link: "/mobile-accessories/chargers" },
//       { id: 3, name: "Cables", link: "/mobile-accessories/cables" },
//     ],
//   },
//   {
//     id: 4,
//     name: "Gaming",
//     link: "/gaming",
//     subCategories: [
//       { id: 1, name: "Gaming Mouse", link: "/gaming/mouse" },
//       { id: 2, name: "Gaming Keyboard", link: "/gaming/keyboard" },
//       { id: 3, name: "Gaming Headphones", link: "/gaming/headphones" },
//     ],
//   },
// ];

const Header = () => {
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [categories, setCategories] = useState([]);
  // const [catwiseProduct, setCatWiseProduct] = useState([]);
  const [hoveredCategoryId, setHoveredCategoryId] = useState(null);
  const { addtoCartProduct, setAddtocartProduct } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getCategorywisedata();
  }, []);

  const getCategorywisedata = async () => {
    const res = await Helpers(`/admin/subcategory/catwise-subcat`, "GET");
    if (res && res?.status) {
      setCategories(res?.data);
    } else {
    }
  };

  const handleCategorywiseProduct = async (catId, subCatId) => {
    if (catId && subCatId) {
      let data = {
        category: catId,
        subcategory: subCatId,
      };
      const res = await Helpers(
        `/admin/product/get-by-category-subcategory`,
        "POST",
        data
      );
      if (res && res?.status) {
        navigate("/categorywiseproduct", { state: res?.data });
        // setCatWiseProduct(res?.data);
      } else {
      }
    }
  };

  const toggleCategory = (categoryId) => {
    setExpandedCategories((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  return (
    <header style={{ position: "fixed", width: "100%", top: 0, zIndex: 1000 }}>
      <div style={{ background: "#000", padding: "6px 0" }}>
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              color: "white",
              fontSize: 24,
              fontWeight: "bold",
              marginLeft: isMobile ? 12 : 0,
              cursor: "pointer",
            }}
            onClick={() => navigate("/")}
          >
            Xcess
          </div>

          {/* Desktop Navigation */}
          {!isMobile && (
            <nav style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <button
                style={{
                  background: "transparent",
                  border: "none",
                  color: "white",
                  fontSize: 15,
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                  padding: "10px 15px",
                  cursor: "pointer",
                }}
                onClick={() => navigate("/")}
              >
                Home
              </button>
              {categories?.map((category) => (
                <div
                  key={category.id}
                  style={{ position: "relative" }}
                  onMouseEnter={() => setHoveredCategoryId(category.id)}
                  onMouseLeave={() => setHoveredCategoryId(null)}
                >
                  <button
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "white",
                      fontSize: 15,
                      fontWeight: 500,
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      padding: "10px 15px",
                      cursor: "pointer",
                    }}
                  >
                    {category.name}
                    <ChevronDown size={16} />
                  </button>

                  {/* Dropdown */}
                  {hoveredCategoryId === category?.id && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        background: "#fff",
                        boxShadow: "0 5px 15px rgba(0,0,0,0.15)",
                        padding: "10px 0",
                        zIndex: 999,
                        minWidth: 220,
                      }}
                    >
                      {category?.subCategories?.map((sub) => (
                        <div
                          key={sub.id}
                          onClick={() =>
                            handleCategorywiseProduct(category?.id, sub?.id)
                          }
                          // href="/categorywiseproduct"
                          title={sub.name}
                          style={{
                            color: "#333",
                            textDecoration: "none",
                            display: "block",
                            padding: "8px 25px",
                            fontSize: 14,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            minWidth: 200,
                            maxWidth: 250,
                            cursor: "pointer",
                          }}
                          onMouseOver={(e) =>
                            (e.target.style.color = "#ff0000")
                          }
                          onMouseOut={(e) => (e.target.style.color = "#333")}
                        >
                          {sub?.name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
              <button
                style={{
                  background: "transparent",
                  border: "none",
                  color: "white",
                  fontSize: 15,
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                  padding: "10px 15px",
                  cursor: "pointer",
                }}
                onClick={() => navigate("/contactus")}
              >
                Contact us
              </button>
            </nav>
          )}

          {/* Icons */}
          <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
            <button style={iconBtnStyle}>
              <Search size={22} />
            </button>

            <div style={{ position: "relative" }}>
              <button
                style={iconBtnStyle}
                onClick={() => {
                  navigate("/addtocart");
                }}
              >
                <ShoppingCart size={22} />
              </button>
              {/* Badge */}
              <span
                style={{
                  position: "absolute",
                  top: -5,
                  right: -5,
                  background: "white",
                  color: "black",
                  borderRadius: "50%",
                  width: 16,
                  height: 16,
                  fontSize: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {addtoCartProduct}
              </span>
            </div>

            {isMobile && (
              <button
                style={iconBtnStyle}
                onClick={() => setShowMobileMenu(true)}
              >
                <Menu size={24} />
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobile && showMobileMenu && (
        <div style={mobileMenuStyle}>
          <div style={mobileMenuHeaderStyle}>
            <h5 style={{ margin: 0 }}>Menu</h5>
            <button
              onClick={() => setShowMobileMenu(false)}
              style={iconBtnStyle}
            >
              <X size={24} />
            </button>
          </div>

          <div>
            {categories.map((category) => (
              <div key={category.id}>
                <button
                  onClick={() => toggleCategory(category.id)}
                  style={mobileCategoryBtnStyle}
                >
                  {category.name}
                  {expandedCategories.includes(category.id) ? (
                    <Minus size={18} />
                  ) : (
                    <Plus size={18} />
                  )}
                </button>

                {expandedCategories.includes(category.id) && (
                  <div style={{ background: "#000", padding: "10px 0" }}>
                    {category.subCategories.map((sub) => (
                      <a
                        key={sub.id}
                        href="/categorywiseproduct"
                        style={mobileSubLinkStyle}
                        onMouseOver={(e) => (e.target.style.color = "#ff0000")}
                        onMouseOut={(e) =>
                          (e.target.style.color = "rgba(255,255,255,0.7)")
                        }
                      >
                        {sub.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

// Styles
const iconBtnStyle = {
  background: "transparent",
  border: "none",
  color: "white",
  padding: 8,
};

const mobileMenuStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: 300,
  height: "100%",
  background: "#1a1a1a",
  color: "white",
  zIndex: 9999,
  overflowY: "auto",
  transition: "transform 0.3s ease-in-out",
};

const mobileMenuHeaderStyle = {
  padding: "20px",
  borderBottom: "1px solid #444",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const mobileCategoryBtnStyle = {
  color: "white",
  padding: "12px 20px",
  fontSize: 15,
  fontWeight: 500,
  width: "100%",
  textAlign: "left",
  border: "none",
  background: "transparent",
  borderBottom: "1px solid rgba(255,255,255,0.1)",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const mobileSubLinkStyle = {
  color: "rgba(255,255,255,0.7)",
  display: "block",
  padding: "8px 35px",
  textDecoration: "none",
  fontSize: 14,
};

export default Header;
